'use client';

import { getClasses } from '@/_utils/classnames';
import { motion } from 'framer-motion';
import {
  Button,
  ButtonGroup,
  Icon,
  Flex,
  Text,
  InlineUnsafe,
} from '@/_components';
import type { FC } from 'react';
import type { ToastProps } from './Toast.types';
import styles from './Toast.module.css';

export const Toast: FC<ToastProps> = ({ type = 'info', message, onClose }) => {
  const toastClasses: string = getClasses(styles.toast, {
    [styles.toastInfo]: type === 'info',
    [styles.toastSuccess]: type === 'success',
    [styles.toastError]: type === 'error',
  });

  return (
    <motion.div
      initial={{ translateY: '-12px', opacity: 0 }}
      animate={{ translateY: 0, opacity: 1 }}
      className={toastClasses}
      onClick={onClose}
    >
      <Flex gap={4} isYCentered={true}>
        {type === 'error' && <Icon name="warning" size={20} />}
        <Text type="small" color="currentcolor">
          <InlineUnsafe text={message} />
        </Text>
      </Flex>
      {type !== 'success' && (
        <ButtonGroup className={styles.toastButtons}>
          <Button
            intent="white"
            onClick={onClose}
            value="Close"
            iconLeft="x"
            isIconOnly={true}
            size="small"
          />
        </ButtonGroup>
      )}
    </motion.div>
  );
};
